import { render } from "./SummaryBox.vue?vue&type=template&id=30d9a12d&scoped=true"
import script from "./SummaryBox.vue?vue&type=script&lang=js"
export * from "./SummaryBox.vue?vue&type=script&lang=js"

import "./SummaryBox.vue?vue&type=style&index=0&id=30d9a12d&scoped=true&lang=css"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d9a12d"]])

export default __exports__